export default { 
    influencer: {}
}